import client from 'client';

import { SERVER_URL } from 'constants/index';

const downloadFile = async (transferId, objectId, header = {}) => {
    try {
        const link = `${SERVER_URL}/api/v1/transfers/${transferId}/objects/${objectId}/downloadurl`;

        const downloadLink = await client.get(link, { headers: header });

        if(downloadLink) {
            const a = document.createElement('a');
            a.download = true;
            a.href = downloadLink.url;
            a.click();
        }
    } catch(e) {}
}

export default downloadFile;